import api from '../lib/api';

const adminService = {
  // Get the editorial review queue
  getQueue: (params) => api.get('/admin/queue', { params }),

  // Get the archive of past editorial decisions
  getArchive: (params) => api.get('/admin/archive', { params }),

  // Get full detail of a queued article
  getQueuedArticle: (id) => api.get(`/admin/queue/${id}`),

  // Approve an article (publishes it)
  approveArticle: (id, note) => api.post(`/admin/articles/${id}/approve`, { note }),

  // Reject an article
  rejectArticle: (id, note) => api.post(`/admin/articles/${id}/reject`, { note }),

  // Request revision with notes
  requestRevision: (id, note) => api.post(`/admin/articles/${id}/request-revision`, { note }),

  // Delete an article (thorough cleanup: content blocks + notifications)
  deleteArticle: (id) => api.delete(`/admin/articles/${id}`),

  // Admin management (Super Admin only for promote/demote)
  getUsers: (params) => api.get('/admin/users', { params }),
  promoteAdmin: (email) => api.post('/admin/promote', { email }),
  demoteAdmin: (userId) => api.post('/admin/demote', { userId }),

  // Admin analytics (platform-wide)
  getAnalytics: (params) => api.get('/admin/analytics', { params }),
};

export default adminService;
